import { useState } from "react";
import { useSelectorApp } from "../../lib/redux";
import { auth } from "../../lib/firebase";
import Button from "./Button";
import ModalCreateAccountFromAnonymous from "../Modal/ModalCreateAccountFromAnonymous";
import { BUTTON_CREATE_ACCOUNT } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const ButtonCreateAccountFromAnonymous = ({
  fullWidth = false,
  sx = {},
  color = "secondary",
  hasShadow = false,
}) => {
  const { t } = useTranslationApp();
  const { user } = useSelectorApp((state) => state.auth);
  const [modalOpen, setModalOpen] = useState(false);
  const currentUser = auth.currentUser;
  const isAnonymous = currentUser?.isAnonymous || user?.isAnonymous;

  if (!isAnonymous) {
    return null;
  }

  return (
    <>
      <Button
        id="button-create-account-from-anonymous"
        color={color}
        hasShadow={hasShadow}
        fullWidth={fullWidth}
        sx={sx}
        onClick={() => setModalOpen(true)}
      >
        {t(BUTTON_CREATE_ACCOUNT)}
      </Button>
      <ModalCreateAccountFromAnonymous
        modalOpen={modalOpen}
        onCloseModal={() => setModalOpen(false)}
      />
    </>
  );
};

export default ButtonCreateAccountFromAnonymous;
